"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var ChellRadioGroup =
/** @class */
function (_super) {
  __extends(ChellRadioGroup, _super);

  function ChellRadioGroup(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = function (index) {
      return function (event, data) {
        _this.setState({
          selectedIndex: index
        });

        if (_this.props.onChange) {
          _this.props.onChange(index);
        }
      };
    };

    _this.renderOptions = function (id, options, disabled, style) {
      return React.createElement(semantic_ui_react_1.Grid, {
        centered: true,
        columns: 2,
        relaxed: true,
        padded: true
      }, options.map(function (option, index) {
        return React.createElement(semantic_ui_react_1.Grid.Column, {
          key: id + "-" + option,
          textAlign: 'center'
        }, React.createElement(semantic_ui_react_1.Form.Radio, {
          checked: _this.state.selectedIndex === index,
          disabled: disabled,
          label: {
            children: option,
            style: style
          },
          name: option,
          onChange: _this.handleChange(index),
          value: index
        }));
      }));
    };

    _this.state = {
      selectedIndex: 0
    };
    return _this;
  }

  ChellRadioGroup.prototype.render = function () {
    var _a = this.props,
        disabled = _a.disabled,
        id = _a.id,
        options = _a.options,
        style = _a.style,
        title = _a.title;
    return React.createElement(semantic_ui_react_1.Form, {
      style: style
    }, React.createElement(semantic_ui_react_1.Form.Field, null, title), this.renderOptions(id, options, disabled, style));
  };

  ChellRadioGroup.defaultProps = {
    disabled: false,
    style: {},
    title: 'How to calculate distance between two residues:'
  };
  return ChellRadioGroup;
}(React.Component);

exports.ChellRadioGroup = ChellRadioGroup;